import { Button, Stack, Typography } from '@mui/material';

// used to select a contract state in the filter menu
function StateFilterMenu({ modifyFilters, closeFilterMenu }) {
  // apply filter and close menu
  const applyStateFilter = (stateType) => {
    modifyFilters('state', stateType);
    closeFilterMenu();
  };

  return (
    <Stack spacing={1}>
      <Button onClick={() => applyStateFilter('spending')}>Spending</Button>
      <Button onClick={() => applyStateFilter('not_spending')}>Not Spending</Button>
      <Button onClick={() => applyStateFilter('questionable')}>Questionable</Button>
      <Button onClick={() => applyStateFilter('pre_launch')}>Pre Launch</Button>
      <Button onClick={() => applyStateFilter('scheduled')}>Scheduled</Button>
      <Button onClick={() => applyStateFilter('incomplete')}>Incomplete</Button>
      <Button onClick={() => applyStateFilter('ended')}>Ended</Button>
    </Stack>
  );
}

export default StateFilterMenu;
